module.exports = __webpack_public_path__ + "static/amazon-646e8352ba20f55c76bd9203519a6caa.png";